import { Assets } from './Assets'

export const AllExpenses = ({ expenses, handleOnClick }) => {
  const allExpenses = expenses || []
  return (
    <Assets
      assets={allExpenses}
      handleOnClick={handleOnClick}
      category={'AllExpenses'}
    />
  )
}
